<div class="min-h-screen px-4 py-8 md:px-8">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@deleteAccountTitle">Delete Account</h1>

  <div class="w-full rounded-[12px] bg-white p-8 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="mb-4 flex items-center gap-2.5 text-black">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      </svg>
      <span class="text-[18px] font-[600]" i18n="@@deleteAccountTitle">Delete Account</span>
    </div>

    <div class="bg-bg mb-8 h-[1.5px]"></div>

    @if (apiError()) {
      <div class="mb-6 flex items-center gap-3 rounded-[8px] border border-red-100 bg-red-50 px-4 py-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" class="text-red-500">
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M256 42.667c117.803 0 213.334 95.53 213.334 213.333S373.803 469.334 256 469.334S42.667 373.803 42.667 256S138.197 42.667 256 42.667m48.918 134.25L256 225.836l-48.917-48.917l-30.165 30.165L225.835 256l-48.917 48.918l30.165 30.165L256 286.166l48.918 48.917l30.165-30.165L286.166 256l48.917-48.917z" />
        </svg>
        <div class="text-left">
          <h2 class="text-[14px] font-semibold text-red-600" i18n="@@deleteAccountErrorTitle">
            {{ isAr() ? "حدث خطأ ما" : "Something went wrong" }}
          </h2>
          <p class="text-[12px] text-red-500">{{ apiError() }}</p>
        </div>
      </div>
    }

    <div class="mb-8 rounded-[12px] border-2 border-red-500 bg-white p-6">
      <div class="mb-3 flex items-center gap-2 text-red-600">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2zm0-6h2v4h-2z" />
        </svg>
        <span class="text-[16px] font-[700]" i18n="@@deleteAccountWarning">Warning!</span>
      </div>
      <p class="text-[15px] leading-[1.6] font-[500] text-gray-700" i18n="@@deleteAccountWarningText">
        {{
          isAr()
            ? "سيؤدي حذف حسابك إلى إزالة جميع بياناتك نهائيًا. يمكنك استعادة حسابك في غضون 30 يومًا. بعد ذلك، سيتم حذف حسابك نهائيًا ولا يمكن استعادته."
            : "Deleting your account will permanently remove all your data. You can restore your account within 30 days. After that, your account will be permanently deleted and cannot be recovered."
        }}
      </p>
    </div>

    <div class="space-y-6">
      <h2 class="text-[16px] font-[700] text-black" i18n="@@deleteAccountPolicyIntroQuestion">
        Please read Account Deletion Policy before take action'
      </h2>

      <div>
        <h3 class="mb-2 text-[15px] font-[700] text-black" i18n="@@deleteAccountPolicyTitle">
          Account Deletion Policy'
        </h3>
        <p class="text-[14px] text-gray-600" i18n="@@deleteAccountPolicyIntro">
          By proceeding with account deletion, please be aware of the following:'
        </p>
      </div>

      <div class="flex flex-col gap-6">
        @for (item of checklist; track item.id; let i = $index) {
          <div class="group flex cursor-pointer items-start gap-3" (click)="toggleCheck(i)">
            <div class="mt-1 shrink-0">
              @if (item.checked) {
                <svg class="fill-success-bright" width="22" height="22" viewBox="0 0 24 24">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              } @else {
                <svg width="22" height="22" viewBox="0 0 24 24" class="fill-border-input group-hover:fill-gray-400">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                </svg>
              }
            </div>
            <div>
              <h4 class="text-[15px] font-[600] text-gray-900">{{ isAr() ? item.titleAr : item.title }}</h4>
              <p class="text-[13px] leading-relaxed text-gray-500">{{ isAr() ? item.descAr : item.description }}</p>
            </div>
          </div>
        }
      </div>

      <h2 class="pt-4 text-center text-[18px] font-[700] text-red-600" i18n="@@deleteAccountConfirmQuestion">
        Are you absolutely sure you want to Delete your account?
      </h2>

      <div class="flex items-center gap-3 pt-4 md:ms-auto md:w-1/2">
        <button
          type="button"
          (click)="onCancel()"
          class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-[8px] border px-8 py-2.5 text-[14px] font-[600]"
          i18n="@@deleteAccountCancelButton">
          Cancel'
        </button>
        <button
          type="button"
          (click)="onSave()"
          [disabled]="!allChecked || loading()"
          class="bg-primary hover-bg-primary-hover min-w-[150px] cursor-pointer rounded-[8px] px-8 py-2.5 text-[14px] font-[600] text-white transition-all disabled:opacity-50">
          <div class="flex items-center justify-center gap-2">
            @if (loading()) {
              <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
            }
            <span i18n="@@deleteAccountSaveButton">
              {{ loading() ? "Deleting..." : "Save" }}
            </span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
